<template>
    <div>
        <createTRWorkFile/>
    </div>
</template>

<script>
import createTRWorkFile from '../../../components/tax/taxRollWorkFile/createTRWorkFile.vue';

export default {
  name: 'createTRWorkFileMain',
  data() {
    return { };
  },
  components: {
    createTRWorkFile,
  },
};
</script>
